"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToasts = void 0;
const getToasts = state => state.toasts.entities;
exports.getToasts = getToasts;